import { PaymentProvider } from "../GetData/Context/PaymentContext";

export default function ({ children }) {
    return (
        <PaymentProvider>
            {children}
        </PaymentProvider>
    )
}
